import type {Locale} from 'antd/es/locale';
import type {ReactNode} from 'react';

import {ConfigProvider} from 'antd';
import {jalaliLocale} from '../../locale';

import {getDatePickerPopupContainer} from '../../utils/pickerPopup';
import {antdDatePickerTheme} from './antdDatePickerTheme';

export type AntdDatePickerProviderProps = {
  children: ReactNode;
  locale?: Locale;
};

/** Scoped antd config for DatePicker / antd-jalali only — not a global app theme. */
export function AntdDatePickerProvider({
  children,
  locale = jalaliLocale
}: AntdDatePickerProviderProps) {
  return (
    <ConfigProvider
      theme={antdDatePickerTheme}
      locale={locale}
      direction="rtl"
      getPopupContainer={getDatePickerPopupContainer}
    >
      {children}
    </ConfigProvider>
  );
}
